<template>
  <FormulateInput
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :name="`${field.name}-${id}-${index}`"
    :label="null"
    :help="true"
    :value="computedValue"
    @input="handleInput"
  />
</template>

<script>
export default {
  props: {
    value: {},
    field: {},
    id: {},
    index: {},
  },
  emits: ['input'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return typeof this.value === 'string' ? Number(this.value) : this.value
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', Number(newValue))
    },
  },
}
</script>
